import React, { useEffect, useState } from 'react'
import { Box, Flex,  Text, Checkbox, Button, Stack } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import dragHandle from 'assets/images/DragHandle.svg'
import { useMediaQuery } from 'react-responsive'

interface IFooterBottomNavProps {
  textContinue?: string
  isChecked?: boolean
  isLoadingConfirm?: boolean
  onAction: () => void
  onTermCondition?: () => void
  onGetFile?: () => void
  onChecked?: (e:boolean) => void
}

const FooterBottomNav = ({
  textContinue = 'Confirmar solicitud',
  isChecked = false,
  isLoadingConfirm = false,
  onAction = () => { },
  onTermCondition = () => { },
  onGetFile = () => { },
  onChecked = (e:boolean) => { },
}: IFooterBottomNavProps) => {
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' })
  const [isCheckedTyC, setIsCheckedTyC] = useState<boolean>(false)
  const handleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsCheckedTyC(e.target.checked)
    onChecked(e.target.checked)
  }
  
  useEffect(() => {
    setIsCheckedTyC(isChecked)
 }, []);

  return (
    <Flex  
      id='bottomNav'
      data-testid='tyc'
      backgroundColor='white'
      align='center'
      p={['8px 16px 24px', '10px 18px']}
      boxShadow='0px -4px 6px 0px rgba(0,0,0,0.1)'
      borderTopRadius={['16px', '0px']}
      position='fixed'
      bottom={0}
      color='white'
      zIndex={10}
      h={['159.14px','84px']}
      w= '100%'
      direction={['column', 'row']}
      gap='12px'
      justify-content='space-between'
    >
      { isMobile && <Stack><img src={dragHandle} alt="" /></Stack> }
      <Flex data-testid='tyc-accept' w={['328px', '478px']} alignItems={'start'} gap='8px' >
        <Checkbox data-testid='tyc-checkbox' onChange={handleCheckbox} isChecked={isChecked} mt={[4,0]} />
        <Box id='bottomNav-Check' data-testid='tyc-label' textStyle='labelLg' w={['284px', '420px']}  ml={'8px'} color='grey.120' >
          {'Acepto los '}
          <Text data-testid='tyc-label-terminos' textStyle='labelLgBoldUnderline' color='primary.500' as='span'  style={{ cursor: 'pointer' }} onClick={onTermCondition}>términos y condiciones</Text>
          {' y declaro y garantizo que la empresa cumple con los '}
          <Text data-testid='tyc-label-requisitos' textStyle='labelLgBoldUnderline'  color='primary.500' as='span' style={{ cursor: 'pointer' }} onClick={onGetFile} >requisitos técnicos y de seguridad</Text>
        </Box>  
      </Flex>      
      <Flex flex={1} justifyContent='end'>
        <Box w={['328px','177px']} >
          <Button data-testid='tyc-button' isDisabled={!isCheckedTyC || isLoadingConfirm} isLoading={isLoadingConfirm} loadingText={textContinue} h='40px' w={['328px','177px']} variant='tertiary' onClick={onAction} rightIcon={<ChevronRightIcon boxSize={'20px'}/>} >
            {textContinue}
          </Button>
        </Box>
      </Flex>
    </Flex>
  )
}

export default FooterBottomNav

